import { render, staticRenderFns } from "./UtilTabs.vue?vue&type=template&id=3c779f30&scoped=true"
import script from "./UtilTabs.vue?vue&type=script&lang=js"
export * from "./UtilTabs.vue?vue&type=script&lang=js"
import style0 from "./UtilTabs.vue?vue&type=style&index=0&id=3c779f30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c779f30",
  null
  
)

export default component.exports